import * as React from "react";
import { cn } from "@/lib/utils";

interface SectionContainerProps extends React.HTMLAttributes<HTMLElement> {
  as?: "section" | "div" | "header" | "footer";
  innerClassName?: string;
}

export function SectionContainer({
  as: Tag = "section",
  className,
  innerClassName,
  children,
  ...rest
}: SectionContainerProps) {
  return (
    <Tag className={cn("py-12 md:py-20 lg:py-28", className)} {...rest}>
      <div className={cn("max-w-7xl mx-auto px-6", innerClassName)}>{children}</div>
    </Tag>
  );
}
